<div class="transactions cash">
  <div class="row middle-xs filters">
    <div class="datepicker-container" [class.unclickable]="initialDateIsSet">
      <mat-form-field (click)="picker.open()">
        <input
          matInput
          readonly
          placeholder="Fecha de inicio"
          class="general-hide"
          [matDatepicker]="picker"
          [(ngModel)]="beginDate"
          (dateInput)="
            changeBeginDate($event.target.value); pickerEnd.open(); applyToday()
          "
        />
        <div class="parsed-date">{{ label.initial }}</div>
        <img class="calendar-arrow" src="/images/icons/atm-black-arrow.svg" />
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field (click)="pickerEnd.open(); applyToday()">
        <input
          matInput
          readonly
          placeholder="Fecha de fin"
          class="general-hide"
          [matDatepicker]="pickerEnd"
          [min]="beginDate"
          [max]="maxDate"
          [(ngModel)]="endDate"
          (dateInput)="changeEndDate($event.target.value)"
        />
        <div class="parsed-date">{{ label.final }}</div>
        <img class="calendar-arrow" src="/images/icons/atm-black-arrow.svg" />
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="wrapper-search">
      <ul class="belt-pills" [class.unclickable]="initialDateIsSet">
        <li
          class="button-pill-primary"
          [class.button-pill-primary--active]="
            operationType === subTransactionType.ALL
          "
          (click)="changeFilter(1)"
        >
          <span>Todos</span>
        </li>
        <li
          class="button-pill-primary"
          [class.button-pill-primary--active]="
            operationType === subTransactionType.DEPOSITS
          "
          (click)="changeFilter(2)"
        >
          <span>Depósitos</span>
        </li>
        <li
          class="button-pill-primary"
          [class.button-pill-primary--active]="
            operationType === subTransactionType.RETREATS
          "
          (click)="changeFilter(3)"
        >
          <span>Retiros</span>
        </li>
        <li
          class="button-pill-primary"
          [class.button-pill-primary--active]="
            operationType === subTransactionType.TRANSFERS_IN
          "
          (click)="changeFilter(4)"
        >
          <span>Transferencias</span>
        </li>
      </ul>
    </div>
  </div>
  <div
    class="download-control"
    [class.unclickable]="initialDateIsSet"
    *ngIf="standardUser === true"
  >
    <a class="download-excel" (click)="parseData('.transactions-body')">
      Descargar Excel
    </a>
  </div>
  <div class="row table-cash">
    <div class="table-grid-nvo">
      <ul class="header-grid">
        <li
          class="li-text-format"
          [class.child-one]="operationType === 9"
          (click)="setSortingProp('operationDate')"
        >
          Fecha
          <div class="sort-icon"></div>
        </li>
        <li class="li-text-format" [class.child-two]="operationType === 9">
          Hora
        </li>
        <li class="li-number-format" [class.child-three]="operationType === 9">
          Folio
        </li>
        <li
          class="li-text-format"
          [class.child-four]="operationType === 9"
          (click)="setSortingProp('operationType')"
        >
          Movimiento
          <div class="sort-icon"></div>
        </li>
        <li
          *ngIf="operationType === 8 || operationType === 0"
          class="li-text-format"
          (click)="setSortingProp('operationType')"
        >
          Emisora
          <div class="sort-icon"></div>
        </li>
        <li
          [class.child-five]="operationType === 9 || operationType === 3534"
          class="li-number-format"
          (click)="setSortingProp('amount')"
        >
          Monto
          <div class="sort-icon"></div>
        </li>
        <li
          [class.child-six]="operationType === 9"
          class="li-text-format"
          (click)="showTooltipR = true; viewTooltipH(); doShow($event, false)"
          (clickOutside)="showTooltipH = false"
        >
          <div [class.dashedB]="areDeposits === false">Estatus</div>
          <hb-tooltip-component
            class="fixed transactions__tooltip transactions__tooltip--status"
            [style.top]="constTop + 'px'"
            [class.show]="showTooltipH === true && areDeposits === false"
            [text]="helpHeader"
            [relativePosition]="'left'"
            [width]="288"
            [hideShadow]="true"
            [isLarge]="true"
          >
          </hb-tooltip-component>
        </li>
      </ul>
      <div
        class="body-grid"
        (clickOutside)="id = -1"
        (scroll)="onScroll($event)"
        *ngIf="!showSkeleton"
      >
        <ul class="row-grid" *ngFor="let c of transactions; let i = index">
          <li
            [class.child-one]="operationType === 9"
            class="li-text-format"
            (click)="onEvent($event)"
          >
            {{ c.operationDate }}
          </li>
          <li
            [class.child-two]="operationType === 9"
            class="li-text-format"
            (click)="onEvent($event)"
          >
            {{ c.operationTime }}
          </li>
          <li
            [class.child-three]="operationType === 9"
            class="li-number-format"
            (click)="onEvent($event)"
          >
            {{ c.trackingKey }}
          </li>
          <li
            [class.child-four]="operationType === 9"
            class="li-text-format"
            (click)="onEvent($event)"
            on-mouseover="mouseLeave($event, c.operationTitle)"
            (mouseenter)="showTooltipTable($event)"
            (mouseleave)="hideTooltipTable($event)"
          >
            {{ c.operationTitle }}
            <hb-tooltip-component
              *ngIf="!!title"
              class="fixed transactions__tooltip"
              [style.top]="constTopTableTooltip + 'px'"
              [style.left]="constLeftTableTooltip + 'px'"
              [text]="title"
              [relativePosition]="'top'"
            >
            </hb-tooltip-component>
          </li>
          <li
            class="li-text-format"
            (click)="onEvent($event)"
            *ngIf="operationType === 8 || operationType === 0"
          >
            {{ c.issueId }}
          </li>
          <li
            [class.child-five]="operationType === 9 || operationType === 3534"
            class="li-number-format"
            [class.negative-cash]="c.statusColor === 'red'"
            [class.neutro-cash]="c.statusColor === 'gray'"
            [class.normal-cash]="c.statusColor === 'black'"
            (click)="onEvent($event)"
          >
            {{ c.amount | hbCustomFormat: (c.isCupon ? '' : '$0,0.00') }}
          </li>
          <li
            [class.child-six]="operationType === 9"
            *ngIf="c.showTooltip === true"
            class="li-text-format"
            [class.status]="c.showTooltip === true"
            [class.negative-cash]="c.statusColor === 'red'"
            [class.neutro-cash]="c.statusColor === 'gray'"
            [class.normal-cash]="c.statusColor === 'black'"
          >
            <div
              [class.dashedB-normal]="c.statusColor === 'black'"
              [class.dashedB-negative]="c.statusColor === 'red'"
              (click)="doShow($event, true); openTransactionDetails(c)"
              (clickOutside)="showTooltipR = false"
            >
              {{ c.operationStatusName }}
            </div>
          </li>
          <li
            [class.child-six]="operationType === 9"
            *ngIf="c.showTooltip === false"
            class="li-text-format"
            [class.status]="c.showTooltip === true"
            (click)="showTooltipR = false"
            [class.negative-cash]="c.statusColor === 'red'"
            [class.neutro-cash]="c.statusColor === 'gray'"
            [class.normal-cash]="c.statusColor === 'black'"
          >
            {{ c.operationStatusName }}
          </li>
        </ul>
        <div class="none-rows" *ngIf="totalRows <= 0 && !showSkeleton">
          <i class="icon icon-atm-icn-ordenes"></i>
          <div>
            No se han encontrado transacciones, intenta con un intervalo nuevo.
          </div>
        </div>
      </div>
      <div class="body-grid" *ngIf="showSkeleton">
        <ul class="row-grid">
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
        </ul>
        <ul class="row-grid">
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
          <li><span class="skeleton"></span></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row between-xs middle-xs see-more">
    <div class="col-xs-12 start-xs no-padding-left">
      <span>{{ currentRows }} / {{ totalRows }} registros.</span>
      <a (click)="getMore()" [ngClass]="{ active: source.length >= noRows }"
        >Mostrar más</a
      >
    </div>
  </div>
</div>

<app-side-modal
  *ngIf="transactionDetails"
  #sideModal
  (goBack)="hideTransactionDetailsModal()"
  (hideModal)="hideTransactionDetailsModal()"
>
  <div class="transaction-details">
    <span class="transaction-details__concept">{{
      transactionDetails.operationConcept
    }}</span>
    <span class="transaction-details__amount">
      <span class="transaction-details__amount--integer">
        {{ transactionDetails.amount | hbCustomFormat: '$0,0' }}
      </span>

      <span class="transaction-details__amount--decimal">
        {{
          transactionDetails.amount
            | hbCustomFormat: (transactionDetails.amount < 1 ? '.00[0]' : '.00')
        }}
      </span>
    </span>

    <div
      class="transaction-details__field"
      *ngFor="let field of transactionDetails.fields"
    >
      <span class="transaction-details__field-name">
        {{ fieldNames[field] }}
      </span>
      <span class="transaction-details__field-value">
        {{ transactionDetails[field] }}
      </span>
    </div>

    <div class="transaction-details__url" *ngIf="transactionDetails.url">
      <a
        class="transaction-details__url-text"
        [href]="transactionDetails.url"
        target="_blank"
        rel="noreferrer noopener"
      >
        Consulta el comprobante electrónico
      </a>
      <span></span>
      <img
        alt="Comprobante electrónico"
        class="transaction-details__url-icon"
        src="/images/icons/atm-icn-external-link.svg"
      />
    </div>
  </div>
</app-side-modal>
